import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { InviteUser, Role, Status } from 'src/app/model';
import { AdministratorProvider, OrgProvider } from 'src/app/providers';
import {CommonService, ToasterService} from 'src/app/services';

@Component({
  selector: 'app-add-user-in-org-modal',
  templateUrl: './add-user-in-org-modal.component.html',
  styleUrls: ['./add-user-in-org-modal.component.scss']
})
export class AddUserInOrgModalComponent implements OnInit {

  orgId: string = '';
  isGlobleAdmin: boolean = false;
  subject: Subject<boolean>;
  @ViewChild('inviteUserForm') inviteUserForm: NgForm;

  objInviteUser: InviteUser = new InviteUser();
  roles: any[] = [];
  userRoles: Array<Role> = [];

  constructor(public bsModalRef: BsModalRef,
    private toastr: ToasterService,
    private administratorProvider: AdministratorProvider,
    private orgProvider: OrgProvider,
              public commonService: CommonService) { }

  ngOnInit(): void {
    if (this.isGlobleAdmin) {
      this.getRolesForGA();
    } else {
      this.getRolesForOA();
    }
  }

  getRolesForGA() {
    this.administratorProvider.getUserRoles('', true).subscribe(res => {
      if (res.success) {
        this.userRoles = Role.parseArray(res.result);
        for (let i = 0; i < this.userRoles.length; i++) {
          this.roles.push({ key: this.userRoles[i].NAME, value: this.userRoles[i].ID });
        }
      }
    }, err => {
      // Error Handling
    });
  }

  getRolesForOA() {
    this.orgProvider.getUserRolesForOA('').subscribe(res => {
      if (res.success) {
        this.userRoles = Role.parseArray(res.result);
        for (let i = 0; i < this.userRoles.length; i++) {
          this.roles.push({ key: this.userRoles[i].NAME, value: this.userRoles[i].ID });
        }
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for add user in organization
   */
  submitClick() {
    if (this.isGlobleAdmin) {
      this.callApiForGA();
    } else {
      this.callApiForOA();
    }
  }

  callApiForGA() {
    this.administratorProvider.addUserInOrganization(this.orgId, this.objInviteUser).subscribe(res => {
      if (res.success) {
        this.objInviteUser = new InviteUser();
        this.bsModalRef.hide();
        this.subject.next(true);
        this.subject.complete();
        if (res.result && res.result.STATUS == Status.INVITED) {
          this.toastr.success('Invitation sent!');
        } else {
          this.toastr.success('User added successfully!');
        }
      } else {
        this.objInviteUser = new InviteUser();
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  callApiForOA() {
    this.orgProvider.addUserInOrganizationForOA(this.orgId, this.objInviteUser).subscribe(res => {
      if (res.success) {
        this.objInviteUser = new InviteUser();
        this.bsModalRef.hide();
        this.subject.next(true);
        this.subject.complete();
        if (res.result && res.result.STATUS == Status.INVITED) {
          this.toastr.success('Invitation sent!');
        } else {
          this.toastr.success('User added successfully!');
        }
      } else {
        this.objInviteUser = new InviteUser();
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description hide popup
   */
  closeClick() {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }
}
